import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { ImagePicker } from '../ContentPicker'
import { SANS_SERIF_FONT_FAMILY } from '../styles'
import { FieldNew } from '../Field'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: 210,
  },
  text: {
    backgroundColor: '#2a2e31',
    paddingLeft: 21,
    paddingRight: 21,
    paddingTop: 14,
    paddingBottom: 21,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontFamily: SANS_SERIF_FONT_FAMILY,
  },
  brand: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '28px',
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  brandPresent: {
    color: '#ffffff',
  },
  name: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '25px',
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  namePresent: {
    color: 'rgba(255, 255, 255, 0.8)',
  },
  brandOrNameMissing: {
    color: 'rgba(255, 255, 255, 0.24)',
  },
})

interface Props {
  imageId: number | undefined
  onChangeImageId: (id: number | undefined) => void
  brandName: string | undefined
  name: string | null
  error?: string
  className?: string
}

export const Preview: FC<Props> = flowMax(
  addDisplayName('Preview'),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({
    imageId,
    brandName,
    name,
    onChangeImageId,
    error,
    classes,
    className,
    t,
  }) => (
    <FieldNew noMargin error={error} className={className}>
      <div className={classes.container}>
        <ImagePicker
          value={imageId ?? null}
          onChange={(id) => onChangeImageId(id ?? undefined)}
          mode="product"
        />
        <div className={classes.text}>
          <p
            className={cx(
              classes.brand,
              brandName ? classes.brandPresent : classes.brandOrNameMissing
            )}
          >
            {brandName || t('admin.product.preview.brand')}
          </p>
          <p
            className={cx(
              classes.name,
              name ? classes.namePresent : classes.brandOrNameMissing
            )}
          >
            {name || t('admin.product.preview.name')}
          </p>
        </div>
      </div>
    </FieldNew>
  )
)
